export default __webpack_public_path__ + "static/media/calendarIcon.8577aa44.svg";